export const NO_TAXES_MESSAGE_HEADER = 'No Taxes Created';
export const NO_TAXES_MESSAGE_MESSAGE = 'Click "Create New Tax" to get started.';
